import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { TrackedLinkDirective } from 'src/app/core/analytics/directives/tracked-link.directive';

@Component({
  selector: 'app-compact-footer',
  imports: [CommonModule, TranslatePipe, TrackedLinkDirective],
  templateUrl: './compact-footer.component.html',
  styleUrl: './compact-footer.component.scss',
})
export class CompactFooterComponent {
  currentYear = new Date().getFullYear();

  companyInfoLinks = [
    {
      trackId: 'careers',
      textKey: 'compact-footer.companyInfo.careers',
      url: 'https://www.myrocketcareer.com/',
    },
    {
      trackId: 'contact-us',
      textKey: 'compact-footer.companyInfo.contactUs',
      url: 'https://www.rocketclose.com/contact',
    },
    {
      trackId: 'blog',
      textKey: 'compact-footer.companyInfo.blog',
      url: 'https://www.rocketclose.com/blog',
    },
  ];

  siteUseLinks = [
    {
      trackId: 'terms-of-use',
      textKey: 'compact-footer.siteUse.termsOfUse',
      url: 'https://www.rocketclose.com/terms-of-use',
    },
    {
      trackId: 'privacy-policy',
      textKey: 'compact-footer.siteUse.privacyPolicy',
      url: 'https://www.rocketclose.com/privacy-policy',
    },
    {
      trackId: 'disclosures',
      textKey: 'compact-footer.siteUse.disclosures',
      url: 'https://www.rocketclose.com/disclosures-licenses',
    },
    {
      trackId: 'solutions',
      textKey: 'compact-footer.siteUse.solutions',
      url: 'https://www.rocketclose.com/solutions',
    },
  ];

  socialLinks = [
    {
      trackId: 'facebook',
      name: 'Facebook',
      icon: 'assets/icons/facebook-default.svg',
      url: 'https://www.facebook.com/RocketClose',
    },
    {
      trackId: 'instagram',
      name: 'Instagram',
      icon: 'assets/icons/instagram-default.svg',
      url: 'https://www.instagram.com/rocketclose/',
    },
    {
      trackId: 'linkedin',
      name: 'LinkedIn',
      icon: 'assets/icons/linkedin-default.svg',
      url: 'https://www.linkedin.com/company/rocketclose',
    },
  ];
}
